<template>
  <div>
    <navbar/>
    <main>
      <router-view/>
    </main>
    <footerLayout/>
  </div>
</template>

<script>
import navbar from "@/components/layouts/navbar";
import footerLayout from "@/components/layouts/footerLayout";

export default {
  name: "mainLayout",
  components: {
    navbar,
    footerLayout
  }
}
</script>

<style scoped>

</style>